import {object, string} from 'yup';

export default object({email: string().required('Please enter your email address.').email('Email must be in a valid format.')});
